import React from 'react';
import PropTypes from 'prop-types';
import { ModalType } from './ModalTypes';
import {Modal} from "@mui/material";

const InfoContent = ({options, onOk, onCancel }) => {
    return (
        <>
            {options.details && (
                   <div>{options.details}</div>
            )}
                {options.showOkBtn && (
                        <button onClick={onOk}>
                            {options.okLabel}
                        </button>
                )}
                {options.showCancelBtn && (
                        <button onClick={onCancel}>
                            {options.cancelLabel}
                        </button>

                )}

        </>
    );
};

InfoContent.propTypes = {
    options: PropTypes.shape({
        details: PropTypes.node,
        okLabel: PropTypes.node,
        cancelLabel: PropTypes.node,
        showCancelBtn: PropTypes.bool,
        showOkBtn: PropTypes.bool,
    }),
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
};

const ConfirmContent = InfoContent;
const AlertContent = InfoContent;
const ErrorContent = InfoContent;

export const AppModal = ({
                             id,
                             modalType,
                             isOpen,
                             onOk,
                             onClose,
                             onCancel,
                             options = {},
                             data,
                         }) => {

    const ModalComponent = options.modalComponent || Modal;
    const callBacks = {
        onOk,
        onClose,
        onCancel,
    };

    return (
        <ModalComponent
            id={id}
            title={options.title}
            subtitle={options.subtitle}
            open={isOpen}
            options={options}
            appElement={document.getElementById('root')}
            data={data}
            {...callBacks}
        >
            <>
            {modalType === ModalType.INFO && (
                <InfoContent options={options} {...callBacks} />
            )}
            {modalType === ModalType.ALERT && (
                <AlertContent options={options} {...callBacks} />
            )}
            {modalType === ModalType.CONFIRM && (
                <ConfirmContent options={options} {...callBacks} />
            )}
            {modalType === ModalType.ERROR && (
                <ErrorContent options={options} {...callBacks} />
            )}
            </>
        </ModalComponent>
    );
};

AppModal.propTypes = {
    id: PropTypes.string,
    modalType: PropTypes.string,
    isOpen: PropTypes.bool,
    options: PropTypes.shape({
        modalComponent: PropTypes.elementType,
        title: PropTypes.node,
        subtitle: PropTypes.node,
    }),
    data: PropTypes.any,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    onClose: PropTypes.func,
};

export default AppModal;